import { render, staticRenderFns } from "./SDWAN-Client.vue?vue&type=template&id=873ca34e&scoped=true&"
import script from "./SDWAN-Client.vue?vue&type=script&lang=js&"
export * from "./SDWAN-Client.vue?vue&type=script&lang=js&"
import style0 from "./SDWAN-Client.vue?vue&type=style&index=0&id=873ca34e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873ca34e",
  null
  
)

export default component.exports